<template>
    <div>
        <b-card
            class="mt-2"
            >
            <b-row>
                <b-col>
                    <h6 class="font-weight-bold">必須</h6>
                </b-col>
            </b-row>
            <div
                v-for="(v, index) in value"
                class="text-left mb-2"
                v-if="v.aspectConstraint.aspectRequired"
                >
                {{ v.localizedAspectName }}
                <vue-select
                    v-model="v.value"
                    :ref="v.localizedAspectName"
                    :options="v.aspectValues"
                    :get-option-label="(option) => { return option.localizedValue }"
                    :size="size"
                    :reduce="option => option.localizedValue"
                    :filter="filterOption"
                    @input="input"
                    :placeholder="''"
                
                    append-to-body
                    :calculate-position="withPopper"

                    :multiple="v.aspectConstraint.itemToAspectCardinality === 'MULTI'"

                    :taggable="[ 'FREE_TEXT', ].includes(v.aspectConstraint.aspectMode)"
                    :create-option="onCreateOption"
                    >
                </vue-select>
<!--
                    :create-option="option => ({ localizedValue: option, })"
-->
            </div>
        </b-card>

        <b-card
            class="mt-2"
            >
            <b-row>
                <b-col>
                    <h6 class="font-weight-bold">追加情報 (任意)</h6>
                </b-col>
<!--
                <b-col cols="auto">
                    <b-form-checkbox v-model="is_enabled_optionals" switch />
                </b-col>
-->
            </b-row>
            <template>
<!--
            <template v-if="is_enabled_optionals">
-->
                <div
                    v-for="(v, index) in value"
                    class="text-left mb-2"
                    v-if="!v.aspectConstraint.aspectRequired"
                    >
                    {{ v.localizedAspectName }}
                    <template v-if="v.aspectValues">
                        <vue-select
                            v-model="v.value"
                            :ref="v.localizedAspectName"
                            :options="v.aspectValues"
                            :get-option-label="(option) => { return option.localizedValue }"
                            :size="size"
                            :reduce="option => option.localizedValue"
                            :filter="filterOption"
                            @input="input"
                            :placeholder="''"
                        
                            append-to-body
                            :calculate-position="withPopper"

                            :multiple="v.aspectConstraint.itemToAspectCardinality === 'MULTI'"

                            :taggable="[ 'FREE_TEXT', ].includes(v.aspectConstraint.aspectMode)"
                            :create-option="option => ({ localizedValue: option, })"
                            >
                        </vue-select>
                    </template>
                    <template v-else>
                        <b-form-input type="text" v-model="v.value" />
                    </template>
                </div>
            </template>
        </b-card>
    </div>
</template>

<script>
import Fuse from 'fuse.js'
import { createPopper } from '@popperjs/core'

export default {
    components: {
    },
    props: {
        value: {
            type: Array,
            required: true,
            default: [],
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
//        provider: {
//            type: String,
//            required: false,
//            default: 'ebay',
//        },
    },
    data() {
        return {
            values: [],
            is_enabled_optionals: false,
        }
    },
    computed: {
    },
    async mounted() {
    },
    methods: {
        input(value) {
            this.$emit('input', this.value)
        },
        get() {
            const data = {}
            const _value = [ ...this.value ]
            for (let i = 0; i < _value.length; i++) {
                data[_value[i].localizedAspectName] = _value[i].value
            }
            return data
        },
        set(data) {
            const _value = [ ...this.value ]
            let optional = false
            for (let i = 0; i < _value.length; i++) {
                const data_value = data[_value[i].localizedAspectName]

                if (data_value) {

                    if (this.value[i].aspectValues
//                        && this.value[i].aspectConstraint.itemToAspectCardinality === 'MULTI'
                    ) {
                        let data_values = data_value
                        if (!Array.isArray(data_values)) {
                            data_values = [ data_values ]
                        }
                        let vueSelect = this.$refs[_value[i].localizedAspectName]
                        if (vueSelect) {
                            vueSelect = vueSelect[0]
                        }
                        for (let j = 0; j < data_values.length; j++) {
                            vueSelect.select(this.onCreateOption(data_values[j]))
                            vueSelect.onAfterSelect()
                        }
                    } else {
                        this.$utils.set(this.value[i], { value: data_value, })
                    }
                    if (!this.value[i].aspectConstraint.aspectRequired) {
                        optional = true
                    }
                }
            }
            if (optional) {
                this.is_enabled_optionals = true
            }
        },




        onCreateOption(option, a, b, c) {
            return {
                localizedValue: option
            }
        },

        filterOption(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'localizedValue', ],
                shouldSort: true,

                tokenize: true,
//                ignoreLocation: true,

                includeMatches: true,
                minMatchCharLength: 1,
                threshold: 0.9,
            })
setTimeout(() => {
    const dropdownList = document.querySelector('ul.vs__dropdown-menu')
    if (dropdownList) {
        console.log(dropdownList.scrollTop = 0)
    }
} , 1)
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width
            dropdownList.style.height = '350px'

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const vm = this
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })
            
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
    },
}
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}
</style>

